import React, { useEffect, useState } from 'react';
import { useUpdateDataVendorInvoiceMutation } from '../../../api/dataVendorInvoiceApiSlice';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { FormGroup, useForm, Yup } from '../../components';
import { useTranslation } from 'react-i18next';
import BillingInput from './BillingInput';

const DataVendorEditInvoiceModal = ({show, setShow, data}) => {
  const { t } = useTranslation();
  const [update] = useUpdateDataVendorInvoiceMutation();
  const initialValues = { modified_users: (data.modified_users || ''), modified_cpm: (data.modified_cpm || {}) }
  const validationSchema = Yup.object().shape({
    modified_users: Yup.number().allowEmptyString(),
    modified_cpm: Yup.object(),
  })
  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
  });
  const onSubmit = () => {
    update({
      ...formData,
      dataVendorId: data.data_vendor_id,
      year: data.year,
      month: data.month
    }).then(()=>{setShow(false)})
  }
  useEffect(() => {
    const {modified_users, modified_cpm} = data
    setFormData({modified_users, modified_cpm})
  }, [data])

  return (
    <Modal show={show} onHide={()=>(setShow(false))}>
      <Modal.Header closeButton>
        <Modal.Title>{t("edit")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <FormGroup
            label={t("publisherInvoice.users")}
            input="number"
            {...getInputProps("modified_users")}
            placeholder={data.users}/>
          {/*<BillingInput*/}
          {/*  value={getInputProps("modified_cpm").value}*/}
          {/*  onChange={getInputProps("modified_cpm").onChange}*/}
          {/*/>*/}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={()=>(setShow(false))}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          {t("save")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DataVendorEditInvoiceModal;
